const errorLogger = (error, errorInfo) => {
    console.error("Error logged:", error, errorInfo);
  };
  
  export default errorLogger;
  